import { JiraAppRow } from '../components/JiraAppRow';
import type { AppRow } from '../type/AppRow';

export const jiraAppRow: AppRow = {
  key: 'jira',
  name: 'Jira',
  AppComponent: JiraAppRow,
};
